/** Is this a price a shopper can read ("$85", "$65–$85"), as opposed to a note ("Check retailer")?
 *  The drawer, the cards and the preview show the price slot only for a real price. */
export const hasPrice = (price: string | undefined | null): boolean => /\$\s*\d/.test(price ?? '');
